import { AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';

import Api from '@/services/api';
import type { BaseContext } from '@/types';

type ValidateOwasEvaluationRequest = BaseContext & {
	report_id: string;
	file_id: string;
};

type ValidateOwasEvaluationResponse = {
	message: string;
};

type ValidateError = {
	message: string;
};

async function validateEvaluation(params: ValidateOwasEvaluationRequest): Promise<ValidateOwasEvaluationResponse> {
	const url = `/ergonomic-tool/owas/report/${params.report_id}/evaluation`;
	const { data } = await Api.post(url, params);
	return data;
}

export const useValidateOWASEvaluation = () => {
	return useMutation<ValidateOwasEvaluationResponse, AxiosError<ValidateError>, ValidateOwasEvaluationRequest>(
		(payload) => validateEvaluation(payload)
	);
};
